<template>
  <img
    class="object-contain w-full h-14"
    alt="logo"
    src="@/assets/image/logo-cryptopay.svg"
  />
</template>
